import './Faq.scss'

const Faq = () => {
  return (
    <div className="faq">
      <h1>FAQ</h1>

      <section className="faqSection">
        <h2>How is Elo calculated?</h2>
        <p>
          Elo ratings use a K-factor of 30 with a base rating of 1500 for new players.
          After each match, each player's expected win probability is calculated using
          the formula:
        </p>
        <pre>Expected = 1 / (1 + 10 ^ ((OpponentElo - PlayerElo) / 400))</pre>
        <p>
          The player's new rating is then adjusted based on the actual result
          versus the expected result:
        </p>
        <pre>NewElo = OldElo + K * (ActualResult - Expected)</pre>
        <p>
          A win counts as 1, a loss as 0. Draws are ignored.
          Friendly matches and DAS events are excluded from Elo calculations.
        </p>
      </section>

      <section className="faqSection">
        <h2>How is Glicko calculated?</h2>
        <p>
          Glicko-2 extends Elo by adding two additional parameters: rating deviation (RD)
          and volatility. RD measures how uncertain a player's rating is — new or inactive
          players have a higher RD, meaning their rating can change more dramatically.
          Volatility tracks how consistently a player performs.
        </p>
        <p>
          Unlike Elo, Glicko-2 is not updated per match. Instead, it processes all matches
          within a rating period (one month) together, then updates all players — including
          inactive players whose RD increases over time. This means Glicko rankings only
          include active players (more than 20 wins and a match within the last 30 days).
        </p>
      </section>

      <section className="faqSection">
        <h2>What match types are there?</h2>
        <ul>
          <li><strong>ELO</strong> — Competitive matches that count toward Elo and Glicko rankings</li>
          <li><strong>TAP</strong> — Matches using the tapping playstyle</li>
          <li><strong>DAS</strong> — DAS-only event matches, excluded from rankings</li>
          <li><strong>FRIENDLY</strong> — Exhibition/friendly matches, excluded from rankings</li>
        </ul>
      </section>

      <section className="faqSection">
        <h2>Community</h2>
        <p>Join us on Discord:</p>
        <ul>
          <li>
            <a href="https://discord.gg/ByUZZ7bfrd" target="_blank" rel="noopener noreferrer">
              CTM Discord
            </a>
          </li>
          <li>
            <a href="https://discord.gg/Gppp2DzG33" target="_blank" rel="noopener noreferrer">
              CTWC Discord
            </a>
          </li>
        </ul>
      </section>
    </div>
  )
}

export default Faq
